import { Box } from '@mui/material';
import { useContext, useEffect } from 'react';
import { IS_SA } from '../../../../../config/appConfig';
import { OpenPanelCategories, OpenPanelEvents } from '../../../../../constants/openPanelEvents';
import { InvestorStepperContext } from '../../../../../context/investorStepperContext';
import { trackOpenPanelView } from '../../../../../helpers/openPanelHelper';
import { trackCustomerIoView } from '../../../../../helpers/customerIoHelper';
import { InvestorDocumentVerificationGlobal } from './global';
import { InvestorDocumentVerificationKSA } from './ksa';

export const InvestorDocumentVerification = () => {
    const { isKsaInternationalInvestor } = useContext(InvestorStepperContext);
    const useKsaInvestorFlow = IS_SA && !isKsaInternationalInvestor;

    useEffect(() => {
        trackOpenPanelView(OpenPanelEvents.kycStarted, {
            page_name: 'KYC',
            category: OpenPanelCategories.kyc,
        });
        trackCustomerIoView(OpenPanelEvents.kycStarted, {
            page_name: 'KYC',
            category: OpenPanelCategories.kyc,
        });
    }, []);

    return (
        <Box>
            {useKsaInvestorFlow ? (
                <InvestorDocumentVerificationKSA />
            ) : (
                <InvestorDocumentVerificationGlobal />
            )}
        </Box>
    );
};
